import {
    SET_REASON_TYPE,
} from "./ReasonTypeType";

const initialState = {
    reasonTypeDropDown: []
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_REASON_TYPE:
            return {
                ...state,
                reasonTypeDropDown: action.reasonTypeDropDown,
            };
        default:
            return state;
    }
};

export default reducer;
